import { Directive, Output, EventEmitter, HostBinding, HostListener } from '@angular/core'

@Directive({
  selector: '[jmlLibDragAndDrop]'
})
export class DragAndDropDirective {
  @HostBinding('class.fileover') fileOver: boolean
  @Output() fileDropped = new EventEmitter<any>()

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.fileOver = true
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.fileOver = false
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    // when properly using the directive the events should be stopped since they are handled here.
    // however, we use primeng file upload component. This one requires those events and handles drag and drop there.
    // the directive is basically only used to properly populate fileover to the host and apply the fileover class.
    // potentially it is much more powerfull but for now it is not required or used.
    // evt.preventDefault();
    // evt.stopPropagation();
    this.fileOver = false
    let files = evt.dataTransfer.files
    if (files.length > 0) {
      this.fileDropped.emit(files)
    }
  }
}
